import React, { useEffect, useState } from "react";
import Header from "../Presale/Header";
import Footer from "../Footer";
import "../css/blog.css";
import { Container, Row, Col, div, Button, Card } from "react-bootstrap";
import { FaArrowRightLong } from "react-icons/fa6";
import {
    getAllBlogsAction,
    getBlogByIdAction,
} from "../../../services/apiServices";
import { Routes, Route, useParams } from "react-router-dom";

const Blogdetail = () => {
    let { idPrimary } = useParams();
    const [blog, setAllBlogs] = useState([]);
    const [blogById, setBlogs] = useState([]);
    useEffect(() => {
        getAllBlog();
        getBlogbyId();
    }, []);
    const getAllBlog = async () => {
        let res = await getAllBlogsAction();

        if (res) {
            setAllBlogs(res.data.data);
        } else {
            setAllBlogs([]);
        }
    };
    const getBlogbyId = async () => {
        let res = await getBlogByIdAction(idPrimary);
        console.log(res.data.data, "response");
        if (res) {
            setBlogs(res.data.data);
        } else {
            setBlogs([]);
        }
    };

    return (
        <>
            <Header />
            <section className="bg-dark py-5 blogbanner">
                <Container>
                    <Row>
                        <Col lg={12} className="text-center">
                            <div className="heading position-relative z-1">
                                <h1 class="text-primary">
                                    <b>Blog Detail</b>
                                </h1>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <div className="banner-background-overlay"></div>
            </section>
            <section className="py-5">
                <Container>
                    <Row>
                        <Col lg={8} className="mb-4">
                            <div className="blog-container">
                                <div className="blog-post-detail overflow-hidden border-0">
                                    <div className="blog-thumb">
                                        <a href={blogById._image} target="_blank">
                                            <img src={blogById?._image} />
                                        </a>
                                    </div>
                                    <div className="blog-content px-0 pb-0">
                                        <div className="blog-post-category"></div>
                                        <h4 className="blog-post-title">{blogById?._title}</h4>
                                        <div className="blog-post-excerpt">
                                            <p
                                                className="text-grey"
                                                dangerouslySetInnerHTML={{
                                                    __html: blogById?._description,
                                                }}
                                            ></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} className="mb-5">
                            <div className="cardStyle2">
                                <Card className="bg-dark latest-post rounded-0 cardBox2">
                                    <Card.Body>
                                        <div className="mb-4">
                                            <h4>Latest Post</h4>
                                            <hr className="bg-dark" />
                                        </div>
                                        {blog.length > 0 &&
                                            blog.slice(0, 5).map((item) => (
                                                <div className="mb-4">
                                                        <Row className="align-items-center">
                                                            <Col lg={3} sm={3} xs={3}>
                                                                <div className="img-thumb">
                                                                    <img
                                                                        src={item?._image}
                                                                        className=" mb-0 rounded-1"
                                                                        width="150px"
                                                                        height="78px"
                                                                        style={{ objectFit: "cover" }}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={9} sm={9} xs={9} className="ps-0">
                                                                <div>
                                                                    <h5 className="fw-normal">{item?._title}</h5>

                                                                    {/* <div class="blog-post__meta-data text-grey">
                                <span class="blog-post-date">May 5, 2024</span>{" "}
                                <br />
                                <span class="blog-post-avatar">
                                  No Comments
                                </span>
                              </div> */}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                            ))}
                                    </Card.Body>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* <Container>
                <hr className='mt-0 mb-0' />
            </Container> */}
            <Footer className="pt-0" />
        </>
    );
};

export default Blogdetail;
